import { useEffect, useState } from "react";
import Button from "src/Components/Button";
import Modal from "src/Components/Modal/Modal";
import SelectableButtons from "src/Components/Dropdown/SelectableButtons";
import Loading from "src/Components/Loading/Loading";
import { IDeltaOptions } from "src/Interfaces/automaticMarketMakingDelta";
import { getDeltaOptions } from "src/Requests/automaticMarketMakingDelta";
import { packetErrorHandler } from "src/Utils/requestUtils";
import DeltaPortfolio from "./DeltaPortfolio";
import BlackScholesParameters from "./BlackScholesParameters";

const DeltaCalculations = () => {
  const [options, setOptions] = useState<IDeltaOptions>();
  const [accountId, setAccountId] = useState<number>();
  const [baseInstrumentId, setBaseInstrumentId] = useState<string>();
  const [parametersOpen, setParametersOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    getDeltaOptions({ signal: controller.signal }).then((result) => {
      if (controller.signal.aborted) return;
      setOptions(result);
      setAccountId(result.accounts[0]?.id);
      setBaseInstrumentId(result.accounts[0]?.underlyings[0]?.id?.toString());
    }).catch((error) => {
      if (!controller.signal.aborted) packetErrorHandler(error);
    }).finally(() => {
      if (!controller.signal.aborted) setLoading(false);
    });
    return () => controller.abort();
  }, [retry]);

  const account = options?.accounts.find((item) => item.id === accountId);

  if (loading) return <Loading className="!text-sky-600" />;
  if (!options) return <div className="w-40"><Button text="تلاش مجدد" variant="outlined" onClick={() => setRetry((value) => value + 1)} /></div>;

  return (
    <div className="flex flex-col gap-5 w-full min-w-0 pt-5" dir="rtl">
      {parametersOpen && <Modal title="پارامترهای بلک شولز" onClose={() => setParametersOpen(false)} UI={<BlackScholesParameters />}
        modalBoxClassName="!min-w-0 !min-h-0 !w-fit !p-0 !rounded-2xl" />}
      <div className="flex items-end justify-between gap-5 w-full">
        <div className="flex min-w-0 flex-1 items-start gap-6">
          <div className="min-w-0 max-w-[65%]">
            <SelectableButtons label="اکانت" name="accountId" hideSelectAll options={options.accounts.map((item) => ({ id: item.id, name: item.name }))}
              value={accountId ?? ""} onChange={(_, value) => {
                if (value === null) return;
                const next = options.accounts.find((item) => item.id === Number(value));
                setAccountId(next?.id);
                setBaseInstrumentId(next?.underlyings[0]?.id?.toString());
              }} />
          </div>
          {!!account && <div className="min-w-0 flex-1"><SelectableButtons label="نماد پایه" name="baseInstrumentId" hideSelectAll options={account.underlyings}
            value={baseInstrumentId ?? ""} onChange={(_, value) => { if (value !== null) setBaseInstrumentId(value.toString()); }} /></div>}
        </div>
        <div className="w-fit shrink-0"><Button text="پارامترهای بلک شولز" variant="outlined" className="!text-xs !py-2 !leading-4" onClick={() => setParametersOpen(true)} /></div>
      </div>
      {options.accounts.length === 0 && <p className="text-sm text-gray-500">برای اکانت‌های در دسترس، تسک بازارگردانی تعریف نشده است.</p>}
      {accountId && baseInstrumentId && <DeltaPortfolio key={`${accountId}-${baseInstrumentId}`} search={{ accountId, baseInstrumentId }} />}
    </div>
  );
};

export default DeltaCalculations;
